<template>
  <v-container fluid fill-height>
    <v-layout row align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12" v-if="!passwordChange">
          <v-app-bar dark color="primary">
            <v-toolbar-title>Anmelden</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-app-bar>
          <v-card-text>
            <v-form ref="form" v-model="valid">
              <v-text-field
                ref="email"
                name="email"
                label="E-Mail"
                id="email"
                v-model="email"
                :rules="mandatoryFieldRule"
                prepend-icon="person"
                type="email"
                @keyup.enter.native="onSignin"
                required></v-text-field>
              <v-text-field
                ref="password"
                name="password"
                label="Passwort"
                id="password"
                v-model="password"
                :rules="mandatoryFieldRule"
                prepend-icon="lock"
                type="password"
                @keyup.enter.native="onSignin"
                required></v-text-field>
            </v-form>
           <v-alert
              :value="loginFailed"
              type="error"
            >
              Anmelden fehlgeschlagen!
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              :disabled="!valid"
              :loading="loading"
              @click="onSignin"
              color="primary">
                Anmelden
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="elevation-12" v-if="passwordChange">
          <v-app-bar dark color="primary">
            <v-toolbar-title>Passwort ändern</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-app-bar>
          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                name="newPassword"
                label="Neues Passwort"
                id="newPassword"
                v-model="newPassword"
                :rules="passwordRules"
                prepend-icon="lock"
                type="password"
                required></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              type="submit"
              :disabled="!valid"
              :loading="loading"
              @click="onPasswordChanged"
              color="primary">
              Ändern
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    name: 'SignIn',
    data () {
      return {
        email: '',
        password: '',
        newPassword: '',
        valid: false,
        mandatoryFieldRule: [
          v => !!v || 'Dieses Feld darf nicht leer sein'
        ],
        emailRules: [
          v => !!v || 'E-Mail nicht angegeben',
          v => /(.+)@(.+){2,}\.(.+){2,}/.test(v) || 'E-Mail hat nicht die korrekte Form. z.B.: beispiel@test.com'
        ],
        passwordRules: [
          v => !!v || 'Passwort nicht angegeben',
          v => (v && v.length >= 8) || 'Ein Passwort muss min. 8 Zeichen enthalten',
          v => /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/.test(v) || 'Passwort muss enthalten: - min. ein Kleinbuchstaben - min. ein Großbuchstaben - min. eine Ziffer'
        ]
      }
    },
    computed: {
      user () {
        return this.$store.getters.user
      },
      loading () {
        return this.$store.getters.loading
      },
      passwordChange () {
        return this.$store.getters.changePassword
      },
      loginFailed () {
        return this.$store.getters.loginFailed
      }
    },
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.replace(this.$route.query.from)
        }
      },
      loginFailed (loginFailed) {
        if (loginFailed === true) {
          this.clear()
        }
      }
    },
    methods: {
      onSignin () {
        this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
      },
      clear () {
        this.password = ''
      },
      onPasswordChanged () {
        this.$store.dispatch('newUserPassword', {user: this.user, password: this.newPassword})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auth/SignIn.vue